// TODO: This file was created by bulk-decaffeinate.
// Sanity-check the conversion and remove this comment.
const UserConstants = Marty.createConstants([
  'USER_CREATE',
  'USER_CREATE_WITH_EMAIL',
  'SEND_WELCOME_EMAIL',
  'USER_FETCH',
  'USER_UPDATE',
  'FETCH_USERS_FOR_ORG_ID',
  'FETCH_CURRENT_USER',
  'CHANGE_PASSWORD',
  'CLEAR_PASSWORD_VALIDATION_ERRORS',
  'CHECK_USER_EXISTENCE_BY_ORG_HANDLE_AND_EMAIL',
  'CHECK_USER_EXISTENCE_BY_EMAIL',
  'USER_AVATAR_UPLOAD',
  'LOGOUT_USER',
  'EMAIL_ALREADY_REGISTERED',
  'USER_ARCHIVE',
  'ARCHIVE_USERS',
  'FETCH_OAUTH_CODE',
  'FETCH_OAUTH_APP'
])

export default UserConstants



// WEBPACK FOOTER //
// ./src/scripts/constants/UserConstants.js